module.exports = __webpack_public_path__ + "static/media/kuulutused.92835636.svg";